import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface LoginForm {
    phone: string;
    password: string;
}

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    constructor(private http: HttpClient) { }
    get(endPoint: string): Observable<any> {
        return this.http.get(environment.API_URL + endPoint);
    }

    post(endPoint: string, body: any): Observable<any> {
        return this.http.post(environment.API_URL + endPoint, body);
    }

    put(endPoint: string, body: any): Observable<any> {
        return this.http.put(environment.API_URL + endPoint, body);
    }

    delete(endPoint: string): Observable<any> {
        return this.http.delete(environment.API_URL + endPoint);
    }
}